

import React from "react";
import {  Card, CardBody, Button , Row} from "reactstrap";
import { Bar, withResponsiveness } from 'britecharts-react';

const ResponsiveBarChart = withResponsiveness(Bar);
export default function SpaceCapacityTime() {
    const chartContainerStyle = {
        width: '100%',
        height: 'auto',
    };

    const barChartData = [
        { name: '2015', value: 2100 },
        { name: '2016', value: 5000 },
        { name: '2017', value: 4000 },
        { name: '2018', value: 5500 },
        { name: '2019', value: 6500 },
        { name: '2020', value: 4500 },
       
    ];
  return (
    <Card className="widget-flat h-100 mt-3">
      <CardBody>
        <Row >
        <h4 style={{color:'#003247'}} className="header-title float-left col " >SPACE CAPACITY EVALUATION IN TIME</h4>
        <Button  style={{background:'#003247'}} className="float-right"><i className="uil  uil-down-arrow "></i></Button>
        </Row>
                <div className="bar-container " style={chartContainerStyle}>
                    <ResponsiveBarChart
                        isAnimated={false}
                        data={barChartData}
                        isHorizontal={false}
                        height={280}
                        betweenBarsPadding={0.8}
                        colorSchema={['#003247']}
                        margin={{ top: 10, left: 55, bottom: 20, right: 10 }}
                    />
                </div>
      </CardBody>
    </Card>
  );
}
